import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import throwInDevOutsideReact from 'Helpers/throwInDevOutsideReact';
import Sentry from 'Integrations/Sentry';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { hyaMetaOverrideSet } from './hya/metaOverrideSet';
import { nonHYAMetaOverrideSet } from './nonHYA/metaOverrideSet';
import { AccountOpeningV2HYAProposalStepLayout } from './hya/layout';
import { AccountOpeningV2NonHYAProposalStepLayout } from './nonHYA/layout';

const resourceTypeToMetaOverrideSet = {
  AccountOpeningV2HYAProposalStep: hyaMetaOverrideSet,
  AccountOpeningV2NonHYAProposalStep: nonHYAMetaOverrideSet,
};
const resourceTypeToLayout = {
  AccountOpeningV2HYAProposalStep: AccountOpeningV2HYAProposalStepLayout,
  AccountOpeningV2NonHYAProposalStep: AccountOpeningV2NonHYAProposalStepLayout,
};

export const AccountOpeningV2ProposalStepTemplate = ({ resource }) => {
  const { setPageContentCollection, loadPageContentLink } = usePageContentContext();

  // Try to find the metaOverrideSet and Layout specific to this resource type
  const metaOverrideSet = resourceTypeToMetaOverrideSet[resource.type()];
  let layout = resourceTypeToLayout[resource.type()];

  // If they are missing, we should fix that - but we can still render with the default meta overrides
  if (!metaOverrideSet || !layout) {
    const errMsg = `AccountOpeningV2ProposalStepTemplate given unknown type ${resource.type()}`;
    throwInDevOutsideReact(errMsg);
    Sentry.createSentryErrorLog(new Error(errMsg));
    // layout is a required prop, so if we're missing it, we need to explicitly set a default
    if (!layout) {
      layout = MetaLayoutRemainingFields;
    }
  }

  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={layout}
          LayoutProps={{ navigateToLink: loadPageContentLink }}
          resource={resource}
          onSubmit={setPageContentCollection}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2ProposalStepTemplate.defaultProps = {
};

AccountOpeningV2ProposalStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
